module.exports = __webpack_public_path__ + "img/file-lock-fill.a19f16b8.svg";